/** Session key for clinic / services / stocks / vets cache. */
export const MANDATE_STORAGE_KEY = "mandateData";

/** ~3 refresh cycles per day: mandate APIs run at most once per this interval. */
export const MANDATE_STALE_MS = 8 * 60 * 60 * 1000;

export const readMandateSession = () => {
  try {
    const raw = sessionStorage.getItem(MANDATE_STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

const readLastUpdatedMs = () => {
  const parsed = readMandateSession();
  const ts = parsed?.lastUpdatedAt;
  if (!ts) return null;
  const t = new Date(ts).getTime();
  return Number.isNaN(t) ? null : t;
};

/** True when there is no timestamp or data is older than {@link MANDATE_STALE_MS}. */
export const isMandateStale = () => {
  const updatedAt = readLastUpdatedMs();
  if (updatedAt == null) return true;
  return Date.now() - updatedAt >= MANDATE_STALE_MS;
};

/** Milliseconds until the next scheduled refresh from stored `lastUpdatedAt`. */
export const msUntilNextMandateRefresh = () => {
  const updatedAt = readLastUpdatedMs();
  if (updatedAt == null) return 0;
  return Math.max(0, MANDATE_STALE_MS - (Date.now() - updatedAt));
};

/**
 * Save full mandate payload with a fresh `lastUpdatedAt` (ISO string).
 * All countdown logic keys off this field — use the same helper anywhere session mandate data is replaced.
 */
export const writeMandateSession = (data) => {
  const payload = {
    ...data,
    lastUpdatedAt: new Date().toISOString(),
  };
  sessionStorage.setItem(MANDATE_STORAGE_KEY, JSON.stringify(payload));
  return payload;
};

/**
 * Merge into existing session and bump `lastUpdatedAt` (e.g. one screen refreshed only vets).
 */
export const patchMandateSession = (partial) => {
  const prev = readMandateSession() ?? {};
  return writeMandateSession({ ...prev, ...partial });
};
